module.exports = __webpack_public_path__ + "static/media/card_brand_sodexo.099050ff.svg";